import React from 'react';
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/ui/error-boundary';
import { ErrorFallback } from '@/components/common/ErrorFallback';
import { createQueryClient } from './QueryProvider';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  const [queryClient] = React.useState(() => createQueryClient());

  try {
    return (
        <ErrorBoundary fallback={<ErrorFallback />}>
          <QueryClientProvider client={queryClient}>
            <ErrorBoundary fallback={<ErrorFallback />}>
              <AuthProvider>
                <ErrorBoundary fallback={<ErrorFallback />}>
                  <ThemeProvider>
                    <ErrorBoundary fallback={<ErrorFallback />}>
                      <BrowserRouter>
                        <TooltipProvider>
                          {children}
                          <Toaster />
                        </TooltipProvider>
                      </BrowserRouter>
                    </ErrorBoundary>
                  </ThemeProvider>
                </ErrorBoundary>
              </AuthProvider>
            </ErrorBoundary>
          </QueryClientProvider>
        </ErrorBoundary>
    );
  } catch (error) {
    console.error('Provider setup error:', error);
    return <ErrorFallback error={error as Error} />;
  }
};